(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-m-atmosphere-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maison-atmosphere-selector')) {
    class MaisonAtmosphereSelector extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.viewAllLinks = [...this.querySelectorAll('[data-family-view-all]')];
        this.status = this.querySelector('[role="status"]');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.activeIndex = Number.parseInt(this.dataset.activeIndex || '0', 10);
        this.fadeDuration = Number.parseInt(this.dataset.fadeDuration || '220', 10);
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.select(this.activeIndex, false, false, false);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onClick(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;
        this.select(Number.parseInt(tab.dataset.familyIndex, 10), false, true, true);
      }

      onKeydown(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;
        const current = this.tabs.indexOf(tab);
        let next = current;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === current) return;
        event.preventDefault();
        this.select(next, true, true, true);
      }

      onBlockSelect(event) {
        const index = this.tabs.findIndex((tab) => tab.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.select(index, false, false, false);
      }

      select(index, focusTab, announce, animatePanel) {
        if (!this.tabs.length || !this.panels.length) return;
        const safeIndex = Math.max(0, Math.min(index, this.tabs.length - 1));
        const changed = safeIndex !== this.activeIndex;
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === safeIndex;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel, panelIndex) => {
          panel.hidden = panelIndex !== safeIndex;
        });
        this.viewAllLinks.forEach((link) => {
          link.hidden = Number.parseInt(link.dataset.familyViewAll, 10) !== safeIndex;
        });
        this.activeIndex = safeIndex;
        const activeTab = this.tabs[safeIndex];
        const activePanel = this.panels[safeIndex];
        if (focusTab) activeTab.focus();
        if (animatePanel && changed && !this.motionQuery.matches && this.fadeDuration > 0 && activePanel.animate) {
          const media = activePanel.querySelector('.mmas__media');
          const products = [...activePanel.querySelectorAll('.mmas__product, .mmas__view-all--mobile')];
          const activeViewAll = this.viewAllLinks.find(
            (link) => Number.parseInt(link.dataset.familyViewAll, 10) === safeIndex
          );
          if (activeViewAll) products.push(activeViewAll);
          (media || activePanel).animate(
            [
              { opacity: 0 },
              { opacity: 1 }
            ],
            { duration: this.fadeDuration, easing: 'cubic-bezier(.22,.61,.36,1)' }
          );
          products.forEach((product, productIndex) => {
            product.animate(
              [
                { opacity: 0, transform: 'translateY(8px)' },
                { opacity: 1, transform: 'translateY(0)' }
              ],
              {
                duration: Math.max(180, this.fadeDuration),
                delay: Math.round(this.fadeDuration * 0.65) + productIndex * 55,
                easing: 'cubic-bezier(.22,.61,.36,1)',
                fill: 'both'
              }
            );
          });
        }
        if (announce && this.status) {
          this.status.textContent = activeTab.textContent.trim();
        }
      }
    }

    customElements.define('maison-atmosphere-selector', MaisonAtmosphereSelector);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-m-cinematic-editorial-suite"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maison-editorial-suite')) {
    class MaisonEditorialSuite extends HTMLElement {
      connectedCallback() {
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.handleMotionChange = this.handleMotionChange.bind(this);
        this.handleVisibility = this.handleVisibility.bind(this);
        this.motionQuery.addEventListener('change', this.handleMotionChange);
        document.addEventListener('visibilitychange', this.handleVisibility);
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.setPlayback(entry.isIntersecting && !document.hidden);
          });
        }, { rootMargin: '120px 0px', threshold: 0.01 });
        this.observer.observe(this);
        this.handleMotionChange();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.motionQuery) this.motionQuery.removeEventListener('change', this.handleMotionChange);
        document.removeEventListener('visibilitychange', this.handleVisibility);
      }

      getVisibleVideos() {
        return [...this.querySelectorAll('video[autoplay]')].filter((video) => video.offsetParent !== null);
      }

      setPlayback(shouldPlay) {
        this.isVisible = shouldPlay;
        this.getVisibleVideos().forEach((video) => {
          if (shouldPlay && !this.motionQuery.matches) {
            const playPromise = video.play();
            if (playPromise) playPromise.catch(() => {});
          } else {
            video.pause();
          }
        });
      }

      handleMotionChange() {
        this.setPlayback(Boolean(this.isVisible));
      }

      handleVisibility() {
        this.setPlayback(Boolean(this.isVisible) && !document.hidden);
      }
    }

    customElements.define('maison-editorial-suite', MaisonEditorialSuite);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-m-dual-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maison-video-hero')) {
    class MaisonVideoHero extends HTMLElement {
      connectedCallback() {
        this.desktopVideo = this.querySelector('.mmvh__video--desktop');
        this.mobileVideo = this.querySelector('.mmvh__video--mobile');
        this.control = this.querySelector('.mmvh__motion-control');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.reducedMotionQuery.matches;
        this.isVisible = true;

        this.handleBreakpoint = this.syncVideo.bind(this);
        this.handleControl = this.togglePlayback.bind(this);

        this.mobileQuery.addEventListener('change', this.handleBreakpoint);
        this.control?.addEventListener('click', this.handleControl);

        this.observer = new IntersectionObserver((entries) => {
          this.isVisible = entries[0].isIntersecting;
          this.syncVideo();
        }, { threshold: 0.08 });

        this.observer.observe(this);
        this.syncVideo();
      }

      disconnectedCallback() {
        this.mobileQuery?.removeEventListener('change', this.handleBreakpoint);
        this.control?.removeEventListener('click', this.handleControl);
        this.observer?.disconnect();
      }

      get activeVideo() {
        if (this.mobileQuery.matches && this.mobileVideo) return this.mobileVideo;
        return this.desktopVideo;
      }

      syncVideo() {
        const activeVideo = this.activeVideo;

        [this.desktopVideo, this.mobileVideo].forEach((video) => {
          if (video && video !== activeVideo) video.pause();
        });

        if (!activeVideo) return;

        if (this.userPaused || !this.isVisible) {
          activeVideo.pause();
        } else {
          activeVideo.play().catch(() => {});
        }

        this.updateControl(activeVideo.paused);
      }

      togglePlayback() {
        const activeVideo = this.activeVideo;
        if (!activeVideo) return;

        if (activeVideo.paused) {
          this.userPaused = false;
          activeVideo.play().catch(() => {});
          this.updateControl(false);
        } else {
          this.userPaused = true;
          activeVideo.pause();
          this.updateControl(true);
        }
      }

      updateControl(paused) {
        if (!this.control) return;
        this.control.dataset.state = paused ? 'paused' : 'playing';
        this.control.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      }
    }

    customElements.define('maison-video-hero', MaisonVideoHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-m-find-your-diffuser"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maison-diffuser-finder')) {
    class MaisonDiffuserFinder extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.mmdf__track');
        this.cards = [...this.querySelectorAll('.mmdf__card')];
        this.previousButton = this.querySelector('.mmdf__arrow--previous');
        this.nextButton = this.querySelector('.mmdf__arrow--next');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onPrevious = () => this.scrollByCard(-1);
        this.onNext = () => this.scrollByCard(1);
        this.updateButtons = this.updateButtons.bind(this);

        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.track?.addEventListener('scroll', this.updateButtons, { passive: true });
        window.addEventListener('resize', this.updateButtons);

        this.initEntranceAnimation();
        requestAnimationFrame(this.updateButtons);
      }

      disconnectedCallback() {
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.updateButtons);
        window.removeEventListener('resize', this.updateButtons);
        this.observer?.disconnect();
      }

      getStep() {
        const firstCard = this.cards[0];
        if (!firstCard || !this.track) return 0;
        const gap = Number.parseFloat(window.getComputedStyle(this.track).columnGap || '0');
        return firstCard.getBoundingClientRect().width + gap;
      }

      scrollByCard(direction) {
        if (!this.track) return;
        this.track.scrollBy({
          left: this.getStep() * direction,
          behavior: this.motionQuery.matches ? 'auto' : 'smooth'
        });
      }

      updateButtons() {
        if (!this.track || !this.previousButton || !this.nextButton) return;
        const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 2;
        this.previousButton.hidden = !hasOverflow;
        this.nextButton.hidden = !hasOverflow;
        this.previousButton.disabled = this.track.scrollLeft <= 2;
        this.nextButton.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      }

      initEntranceAnimation() {
        if (this.dataset.animate !== 'true' || this.motionQuery.matches || !('IntersectionObserver' in window)) {
          this.cards.forEach((card) => card.classList.add('is-visible'));
          return;
        }

        this.classList.add('mmdf--animate-ready');
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          });
        }, { threshold: 0.16 });
        this.cards.forEach((card) => this.observer.observe(card));
      }
    }

    customElements.define('maison-diffuser-finder', MaisonDiffuserFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-m-windmill"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('maison-windmill')) {
  customElements.define('maison-windmill', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.cards = [...this.querySelectorAll('.wm__card')];
      this.stage = this.querySelector('.wm__stage');
      this.controls = this.querySelector('.wm__controls');
      this.info = this.querySelector('.wm__info');
      this.infoContent = this.querySelector('.wm__info-content');
      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.selected = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.desktop = matchMedia('(min-width: 750px)');
      this.addEventListener('click', e => this.click(e), {signal});
      this.stage.addEventListener('keydown', e => {
        if (!this.wheel || !['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
        e.preventDefault();
        const rtl = getComputedStyle(this).direction === 'rtl';
        if (e.key === 'Home') this.go(0);
        else if (e.key === 'End') this.go(this.cards.length - 1);
        else this.go(this.index + ((e.key === 'ArrowRight') !== rtl ? 1 : -1));
      }, {signal});
      this.stage.addEventListener('pointerdown', e => {
        if (!this.wheel || !e.isPrimary || e.button !== 0) return;
        this.pointer = {id:e.pointerId,x:e.clientX,y:e.clientY};
        this.timerReset();
      }, {signal});
      window.addEventListener('pointerup', e => {
        if (!this.pointer || e.pointerId !== this.pointer.id) return;
        const dx = e.clientX - this.pointer.x, dy = e.clientY - this.pointer.y;
        this.pointer = null;
        if (Math.abs(dx) > Number(this.dataset.threshold) && Math.abs(dx) > Math.abs(dy)) {
          this.suppressUntil = Date.now() + 400;
          const rtl = getComputedStyle(this).direction === 'rtl';
          this.go(this.index + ((dx < 0) !== rtl ? 1 : -1));
        }
        this.timerReset();
      }, {signal});
      window.addEventListener('pointercancel', () => {this.pointer = null; this.timerReset();}, {signal});
      this.addEventListener('pointerenter', e => {if(e.pointerType === 'mouse') {this.hovered=true; this.timerReset();}}, {signal});
      this.addEventListener('pointerleave', () => {this.hovered=false; this.timerReset();}, {signal});
      this.addEventListener('focusin', () => {this.focused=true; this.timerReset();}, {signal});
      this.addEventListener('focusout', () => queueMicrotask(() => {this.focused=this.contains(document.activeElement);this.timerReset();}), {signal});
      document.addEventListener('visibilitychange', () => this.timerReset(), {signal});
      document.addEventListener('shopify:block:select', e => {
        const i = this.cards.findIndex(c => c.dataset.block === e.detail.blockId);
        if (i < 0) return;
        this.selected=true; this.go(i);
      }, {signal});
      document.addEventListener('shopify:block:deselect', e => {
        if (!this.cards.some(c => c.dataset.block === e.detail.blockId)) return;
        this.selected=false;this.timerReset();
      }, {signal});
      this.reduced.addEventListener('change', () => this.timerReset(), {signal});
      this.desktop.addEventListener('change', () => this.layout(), {signal});
      this.observer = new ResizeObserver(() => this.layout());
      this.observer.observe(this.stage);
      this.cards.forEach(c => this.observer.observe(c));
      this.layout();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller=null;
      this.observer?.disconnect(); clearTimeout(this.timer);
      this.infoAnimation?.cancel();
    }
    layout() {
      this.wheel = this.cards.length > 0 && !(this.desktop.matches && this.dataset.desktopLayout === 'grid');
      this.classList.toggle('is-wheel',this.wheel);
      const width = this.desktop.matches ? Math.min(Number(this.dataset.desktopWidth),this.stage.clientWidth*.85) : this.stage.clientWidth*Number(this.dataset.mobileWidth)/100;
      this.style.setProperty('--wm-width',`${width}px`);
      this.stage.tabIndex=this.wheel && this.cards.length>1 ? 0 : -1;
      this.controls.hidden=!this.wheel || this.cards.length<2;
      if(this.info) this.info.hidden=!this.wheel;
      this.render();
      const height=Math.max(0,...this.cards.map(c => c.offsetHeight));
      this.style.setProperty('--wm-height',`${height+64}px`);
      this.measureInfo();
      this.timerReset();
    }
    measureInfo() {
      if(!this.infoContent||!this.wheel) return;
      const measure=document.createElement('div');
      measure.className='wm__info-measure';
      measure.style.width=`${this.infoContent.clientWidth}px`;
      measure.inert=true;
      measure.setAttribute('aria-hidden','true');
      this.info.append(measure);
      let height=0;
      this.cards.forEach(card=>{
        const template=card.querySelector('.wm__info-template');
        if(template) {measure.replaceChildren(template.content.cloneNode(true));height=Math.max(height,measure.offsetHeight);}
      });
      measure.remove();
      this.style.setProperty('--wm-info-height',`${height}px`);
    }
    go(target,auto=false) {
      const n=this.cards.length;
      if (!n) return;
      const next=this.dataset.loop==='true' ? (target%n+n)%n : Math.max(0,Math.min(n-1,target));
      const focused=this.cards.findIndex(c=>c.contains(document.activeElement));
      if(focused>=0 && focused!==next) this.stage.focus({preventScroll:true});
      this.index=next; this.render();
      if(!auto) this.querySelector('.wm__status').textContent=`${this.cards[next].dataset.title} (${next+1}/${n})`;
      this.timerReset();
    }
    render() {
      const n=this.cards.length;
      const angle=Number(this.dataset[this.desktop.matches?'desktopAngle':'mobileAngle']);
      const spread=Number(this.dataset[this.desktop.matches?'desktopSpread':'mobileSpread']);
      const direction=getComputedStyle(this).direction==='rtl'?-1:1;
      this.cards.forEach((card,i)=>{
        let offset=i-this.index;
        if(this.dataset.loop==='true') {
          if(offset>n/2) offset-=n;
          if(offset<-n/2) offset+=n;
        }
        const active=offset===0, visible=Math.abs(offset)<=Number(this.dataset.sides);
        const old=Number(card.dataset.offset);
        card.style.transition=Number.isFinite(old)&&Math.abs(old-offset)>1?'none':'';
        card.dataset.offset=offset;
        card.dataset.active=String(active);
        card.style.setProperty('--wm-angle',`${offset*angle*direction}deg`);
        card.style.setProperty('--wm-x',`${offset*spread*direction}px`);
        card.style.setProperty('--wm-scale',active?'1':String(Number(this.dataset.scale)/100));
        card.style.setProperty('--wm-opacity',!visible?'0':active?'1':String(Number(this.dataset.opacity)/100));
        card.style.zIndex=String(n-Math.abs(offset));
        card.style.visibility=this.wheel&&!visible?'hidden':'';
        card.inert=this.wheel&&!visible;
        card.querySelector('a')?.setAttribute('tabindex',this.wheel&&!active?'-1':'0');
      });
      this.querySelectorAll('[data-index]').forEach((dot,i)=>dot.setAttribute('aria-current',String(i===this.index)));
      const prev=this.querySelector('[data-prev]'),next=this.querySelector('[data-next]');
      if(prev) prev.disabled=this.dataset.loop!=='true'&&this.index===0;
      if(next) next.disabled=this.dataset.loop!=='true'&&this.index===n-1;
      this.updateInfo();
    }
    async updateInfo() {
      if(!this.infoContent || !this.cards.length || this.infoIndex===this.index) return;
      const first=this.infoIndex===undefined;
      this.infoIndex=this.index;
      const request=(this.infoRequest||0)+1;
      this.infoRequest=request;
      this.infoAnimation?.cancel();
      const template=this.cards[this.index].querySelector('.wm__info-template');
      if(!template) return;
      const fragment=template.content.cloneNode(true);
      const duration=Number(this.dataset.infoFade);
      if(!first&&!this.reduced.matches) {
        this.infoAnimation=this.infoContent.animate([{opacity:1},{opacity:0}],{duration:duration*.4,easing:'ease-out',fill:'forwards'});
        try {await this.infoAnimation.finished;} catch {return;}
      }
      if(request!==this.infoRequest||!this.isConnected) return;
      if(this.infoContent.contains(document.activeElement)) this.stage.focus({preventScroll:true});
      this.infoAnimation?.cancel();
      this.infoContent.replaceChildren(fragment);
      if(!first&&!this.reduced.matches) this.infoAnimation=this.infoContent.animate([{opacity:0},{opacity:1}],{duration:duration*.6,easing:'ease-in'});
    }
    click(e) {
      if(Date.now()<(this.suppressUntil||0)) {e.preventDefault();return;}
      if(e.target.closest('[data-prev]')) this.go(this.index-1);
      else if(e.target.closest('[data-next]')) this.go(this.index+1);
      else if(e.target.closest('[data-index]')) this.go(Number(e.target.closest('[data-index]').dataset.index));
      else if(e.target.closest('[data-toggle]')) {
        this.paused=!this.paused;
        e.target.closest('[data-toggle]').textContent=this.paused?this.dataset.play:this.dataset.pause;
        this.timerReset();
      } else {
        const card=e.target.closest('.wm__card');
        if(this.wheel&&card&&card.dataset.active==='false') {e.preventDefault();this.go(this.cards.indexOf(card));}
      }
    }
    timerReset() {
      clearTimeout(this.timer);
      if(!this.isConnected||!this.wheel||this.cards.length<2||this.dataset.autoplay!=='true'||this.paused||this.hovered||this.focused||this.selected||this.pointer||this.reduced.matches||document.hidden) return;
      if(this.dataset.loop!=='true'&&this.index===this.cards.length-1) return;
      this.timer=setTimeout(()=>this.go(this.index+1,true),Number(this.dataset.interval)*1000);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
